module.exports = __webpack_public_path__ + "static/img/son13_active.b6df2c7f.png";